import { isServer } from "../environmentDetection/library";
import log from "../logger/library";

/**
 * Ensure global stats object matches expected interface
 */
export const checkStatsInterface = () => {
    const missing = [];
    if (isServer() || !window?.CBC?.APP) {
        log.error("(checkStatsInterface) Failed to load cbc-stats");
        return;
    }

    if (!window?.CBC?.APP?.PubSub?.publish) {
        missing.push("CBC.APP.PubSub.publish");
    }
    if (!window?.CBC?.APP?.PubSub?.subscribe) {
        missing.push("CBC.APP.PubSub.subscribe");
    }
    if (!window?.CBC?.APP?.SC?.EventTracker?.trackEvent) {
        missing.push("CBC.APP.SC.EventTracker.trackEvent");
    }
    if (!window?.CBC?.APP?.SC?.UTIL?.clearDataLayer) {
        missing.push("CBC.APP.SC.UTIL.clearDataLayer");
    }
    if (!window?.CBC?.APP?.ANA?.ABTESTSCONFIG) {
        missing.push("CBC.APP.ANA.ABTESTSCONFIG");
    }
    if (!window?.CBC?.APP?.DMP?.LOTAME?.audiences) {
        missing.push("CBC.APP.DMP.LOTAME.audiences");
    }
    if (missing.length) {
        log.error(
            `(checkStatsInterface) Unexpected cbc-stats interface, missing: ${missing}`
        );
    }
};
